var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menus_nav", style: { "--theme-color": _vm.themeColor } },
    [
      _c(
        "div",
        { staticClass: "left-aside" },
        _vm._l(_vm.menusList, function (item, index) {
          return _c(
            "div",
            {
              key: index + "_" + item.id,
              class: ["f-item", index === _vm.currentIndex && "active"],
              on: {
                click: function ($event) {
                  return _vm.changeMenu(index, item)
                },
              },
            },
            [_vm._v(" " + _vm._s(item.name) + " ")]
          )
        }),
        0
      ),
      _c("div", { staticClass: "right-aside" }, [
        _c(
          "div",
          { staticClass: "t-list" },
          _vm._l(_vm.childrenList, function (child) {
            return _c(
              "div",
              { key: child.id, staticClass: "t-item" },
              [
                _c("el-image", {
                  staticClass: "img-icon",
                  attrs: { src: child.icon },
                }),
                _c("div", { staticClass: "child-name" }, [
                  _vm._v(" " + _vm._s(child.name) + " "),
                ]),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }